<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >机器人定时任务列表</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="虚拟机"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="是否启用" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.enabled"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入开发编号"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button
                                    status="success"
                                    @click="add"
                                    v-if="isAdmin"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable1"
                    >
                        <vxe-column
                            type="seq"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="删除" width="50">
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="编辑"
                            width="50"
                            show-overflow
                            :visible="isAdmin"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="enabled"
                            title="是否启用"
                            width="100"
                            resizable
                            sortable
                            show-overflow
                        >
                            <template v-slot="{ row }">
                                <vxe-button
                                    size="small"
                                    :status="
                                        row.enabled == 1 ? 'success' : 'warning'
                                    "
                                    @click="updateCronEnabled(row)"
                                    round
                                    >{{ row.enabled == 1 ? "是" : "否" }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="flow_name"
                            title="开发编号"
                            width="120"
                            sortable
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="process_name"
                            title="项目名称"
                            width="140"
                            sortable
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="cron"
                            title="Cron表达式"
                            width="140"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="cron_description"
                            title="Cron表达式描述"
                            width="190"
                            show-overflow
                            resizable
                            sortable
                            ><template v-slot="{ row }">
                                <span>{{ getCronText(row.cron) }} </span>
                            </template></vxe-column
                        >
                        <vxe-column
                            field="create_mail"
                            title="执行人邮箱"
                            width="180"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="create_name"
                            title="执行人"
                            width="100"
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="machine_name"
                            title="机器名称"
                            width="130"
                            sortable
                        ></vxe-column>

                        <vxe-column
                            field="root"
                            title="根目录"
                            width="190"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="remark"
                            title="备注"
                            width="100"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="creator"
                            title="创建人"
                            width="100"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="creation_time"
                            title="创建时间"
                            width="160"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="modifer"
                            title="修改人"
                            width="100"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="modify_time"
                            title="修改时间"
                            width="160"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            { label: '全部数据', value: 10000 },
                        ]"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </va-card-content>
    </va-card>
    <addCron ref="addCronRef" @flashList="findData" />
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted } from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
import XEUtils from "xe-utils";
import { useRouter } from "vue-router";
import addCron from "./addCron.vue";
import cronstrue from "cronstrue/i18n";
const { proxy } = getCurrentInstance();

const tableHeight = ref(0);
const tableData = ref([]);

const addCronRef = ref(null);

const isAdmin = ref(false);

const tablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});

const toolbar = reactive({
    loading: false,
    macOptions: [],
    formData: {
        selectMac: "",
        enabled: "",
        searchKey: "",
    },
});
const bindPC = () => {
    proxy.$api.systemManageAPI
        .getMachineListPsy()
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            toolbar.macOptions = [];
            for (const item of res.data.Data) {
                toolbar.macOptions.push({
                    value: item.PcName,
                    label: item.Abbr,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const add = () => {
    addCronRef.value.openModal();
};
const editEvent = (row) => {
    addCronRef.value.editEvent(row);
};

const findData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [
            toolbar.formData.selectMac,
            toolbar.formData.enabled,
            toolbar.formData.searchKey,
        ],
    };
    proxy.$api.psyManageAPI
        .getRobotCronList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            tableData.value = res.data.Data.dataTable;
            tablePager.currentPage = res.data.Data.currentPage;
            tablePager.pageSize = res.data.Data.pageSize;
            tablePager.totalResult = res.data.Data.totalResult;
            calTableHeight(res.data.Data.dataTable.length);
        })
        .catch((error) => {
            console.log(error);
        });
};

const handlePageChange = () => {
    findData();
};

const calTableHeight = (rowsLength) => {
    let minHeight = window.innerHeight - (65 + 28 + 198);
    let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 30;
    tableHeight.value = Math.max(minHeight, calHeight);
};

const clear = () => {
    toolbar.formData.searchKey = "";
    toolbar.formData.selectMac = "";
    toolbar.formData.enabled = "";
};

const removeRowEvent = async (row) => {
    const type = await VXETable.modal.confirm("确定要删除该Cron吗？");

    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            currentPage: tablePager.currentPage,
            pageSize: tablePager.pageSize,
            searchKey: [row.id],
        };
        proxy.$api.psyManageAPI
            .deleteRobotCron(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "删除成功",
                    status: "success",
                });
                findData();
            })
            .catch((error) => {
                console.log(error);
            });
    }
};

const updateCronEnabled = async (row) => {
    const params = {
        id: row.id,
        enabled: row.enabled === 1 ? 0 : 1,
        modifer: proxy.$store.state.userID,
    };
    proxy.$api.psyManageAPI
        .updateRobotCronEnabled(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            VXETable.modal.message({
                content: "更新成功",
                status: "success",
            });
            findData();
        })
        .catch((error) => {
            console.log(error);
        });
};
const getCronText = (cron) => {
    try {
        let text = cronstrue.toString(cron, {
            locale: "zh_CN",
        });

        const arr = cron.trim().split(/\s+/);

        // 5位 cron:
        // 分 时 日 月 星期

        const day = arr[2];
        const month = arr[3];
        const week = arr[4];

        // 判断是否每天
        const isEveryDay = day === "*" && month === "*" && week === "*";

        if (isEveryDay) {
            text = "每天 " + text;
        }

        return text;
    } catch (e) {
        return cron;
    }
};
onMounted(() => {
    isAdmin.value = proxy.$store.state.isAdmin == "1";
    bindPC();
    findData();
});
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
